/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The UpdateCompanyRequest model module.
* @module model/UpdateCompanyRequest
* @version 2020-12-7
*/
export default class UpdateCompanyRequest {
    /**
    * Constructs a new <code>UpdateCompanyRequest</code>.
    * 会社更新レスポンス
    * @alias module:model/UpdateCompanyRequest
    * @class
    * @param companyName {String} 会社名
    * @param parentGroupId {Number} 親会社ID
    * @param address {String} 住所
    * @param tel {String} 電話番号
    * @param remarks {String} 備考
    * @param representativeName {String} 代表氏名
    */

    constructor(companyName, parentGroupId, address, tel, remarks, representativeName) {
        
        
        this['companyName'] = companyName;
        this['parentGroupId'] = parentGroupId;
        this['address'] = address;
        this['tel'] = tel;
        this['remarks'] = remarks;
        this['representativeName'] = representativeName;
        
    }

    /**
    * Constructs a <code>UpdateCompanyRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/UpdateCompanyRequest} obj Optional instance to populate.
    * @return {module:model/UpdateCompanyRequest} The populated <code>UpdateCompanyRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UpdateCompanyRequest();
                        
            
            if (data.hasOwnProperty('companyName')) {
                obj['companyName'] = ApiClient.convertToType(data['companyName'], 'String');
            }
            if (data.hasOwnProperty('parentGroupId')) {
                obj['parentGroupId'] = ApiClient.convertToType(data['parentGroupId'], 'Number');
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], 'String');
            }
            if (data.hasOwnProperty('tel')) {
                obj['tel'] = ApiClient.convertToType(data['tel'], 'String');
            }
            if (data.hasOwnProperty('remarks')) {
                obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String');
            }
            if (data.hasOwnProperty('representativeName')) {
                obj['representativeName'] = ApiClient.convertToType(data['representativeName'], 'String');
            }
        }
        return obj;
    }

    /**
    * 会社名
    * @member {String} companyName
    */
    'companyName' = undefined;
    /**
    * 親会社ID
    * @member {Number} parentGroupId
    */
    'parentGroupId' = undefined;
    /**
    * 住所
    * @member {String} address
    */
    'address' = undefined;
    /**
    * 電話番号
    * @member {String} tel
    */
    'tel' = undefined;
    /**
    * 備考
    * @member {String} remarks
    */
    'remarks' = undefined;
    /**
    * 代表氏名
    * @member {String} representativeName
    */
    'representativeName' = undefined;




}
